import { Injectable, inject } from '@angular/core';

import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SearchMainService } from './search.main.service';
import { PAGE_TYPE } from '../enums/page-type.enum';

@Injectable({
  providedIn: 'root'
})
export class SearchTypeResolver  {
  private readonly searchService = inject(SearchMainService);

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): string {

    const type = route.data['type'] || PAGE_TYPE.ALL;
    // Use data params to deduce type of page
    const pageTypeMapping = {
      articles: PAGE_TYPE.ARTICLES,
      recipes: PAGE_TYPE.RECIPES,
      products: PAGE_TYPE.PRODUCTS,
      all: PAGE_TYPE.ALL 
    };
    
    this.searchService.pageNumber = 1;
    this.searchService.pageType = pageTypeMapping[type] || PAGE_TYPE.ALL;

    return type;
  }
}
